import { render } from "./BrandHeader.vue?vue&type=template&id=56a5c436&scoped=true"
import script from "./BrandHeader.vue?vue&type=script&lang=js"
export * from "./BrandHeader.vue?vue&type=script&lang=js"

import "./BrandHeader.vue?vue&type=style&index=0&id=56a5c436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a5c436"]])

export default __exports__